export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "incomingCall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Incoming call..."])},
        "hints": {
          "answer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Answer"])},
          "answerVideo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Answer with video"])},
          "decline": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Decline"])}
        }
      },
      "ru": {
        "incomingCall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Входящий звонок..."])},
        "hints": {
          "answer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ответить"])},
          "answerVideo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ответить с видео"])},
          "decline": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Отклонить"])}
        }
      }
    }
  })
}
